import React from "react";
import Button from "react-bootstrap/Button";
import { useTooltips } from "../../TooltipProvider";
import { formatCurrency } from "../../../../../../../../../../utilities/helpers";
import useSeatmapStore from "../../../../../../../../../../stores/seatmapStore";

export default function SeatTooltip({ showFullSeatTip = true, target }) {
  // Zustand
  const data = useSeatmapStore((state) => state.data);
  const selectSpecificSeat = useSeatmapStore(
    (state) => state.selectSpecificSeat,
  );
  const { hideTooltip, tooltipState } = useTooltips();

  let name;
  let price;
  let seatNumber = data?.seats[tooltipState.targetId]?.seatNumber;

  if (target) {
    name = target?.offer?.name;
    price = target?.price;
  }

  const handleSelectSeat = (e) => {
    e.stopPropagation();
    selectSpecificSeat(tooltipState.targetId, target);
    hideTooltip();
  };

  return (
    <div className="htmlTooltip">
      <div className="htmlTop">{name}</div>
      <div className="htmlBody">
        <p className="htmlPrice">{formatCurrency(price)}</p>
        <div className="htmlRow">
          <HTMLSection label={"Section"} value={target?.sectionNumber} />
          <HTMLSection label={"Row"} value={target?.rowNumber} />
          <HTMLSection label={"Seat"} value={seatNumber || "error"} />
        </div>
        {showFullSeatTip && (
          <Button
            variant="secondary"
            size="lg"
            className="htmlButton"
            onClick={(e) => handleSelectSeat(e)}
          >
            Add now
          </Button>
        )}
      </div>
    </div>
  );
}

function HTMLSection({ label, value }) {
  return (
    <div className="htmlSection">
      <p className="htmlPh">{label}</p>
      <p className="htmlP">{value}</p>
    </div>
  );
}
